module.exports = __webpack_public_path__ + "media/luxury-2026/staging-closing-interior-b44364f9.jpg";